import { FeatureFlag } from '@/plugins/split/feature-flags'

export const RL_EMPTY_UNLOCKED_EMAIL = 'RL-Empty-Unlocked-Email'
export const RL_PLACE_ORDER_RECAPTCHA = 'RL-Redemption-reCAPTCHA'
export const SVP_RL_1272_RECIPIENT_SURVEY = 'SVP-RL-1272-recipient-survey'
export const SVP_COMBINABLE_RLS = 'SVP-combinable-rls'
export const SVP_RL_HIDE_FOOTER_LINKS = 'SVP-RL-hide-footer-links'
export const SVP_ADA_CHATBOT_ENABLED = 'svp-ada-chatbot-enabled'
export const USE_NEW_REWARD_CARD = 'RL-1296_userNewRewardCard' // This split is for Mango, please follow the comments in Mango/RewardCard and sub components to finish this clean up
export const RL_HIGH_VOLUME_WARNING = 'RL-high-volume-warning'
export const RX_ADA_PROACTIVE = 'rx-ada-proactive' // Chatbot proactive split
export const RLSF_DATADOG_RUM_METRICS = 'RLSF-Datadog-RUM-Metrics'
export const RX_DISB_LINK = 'rx-disb-link'
export const RX_DISABLE_DISB_LINK = 'rx-disable-disb-link'

// split constant above and enabled values for split below

export const applicationSplits = [
  new FeatureFlag(SVP_COMBINABLE_RLS)
]

export const platformSplits = [
  new FeatureFlag(RL_EMPTY_UNLOCKED_EMAIL),
  new FeatureFlag(RL_PLACE_ORDER_RECAPTCHA),
  new FeatureFlag(SVP_RL_1272_RECIPIENT_SURVEY),
  new FeatureFlag(SVP_RL_HIDE_FOOTER_LINKS),
  new FeatureFlag(SVP_ADA_CHATBOT_ENABLED),
  new FeatureFlag(USE_NEW_REWARD_CARD),
  new FeatureFlag(RL_HIGH_VOLUME_WARNING),
  new FeatureFlag(RX_ADA_PROACTIVE),
  new FeatureFlag(RLSF_DATADOG_RUM_METRICS),
  new FeatureFlag(RX_DISB_LINK),
  new FeatureFlag(RX_DISABLE_DISB_LINK)
]
